import React from "react";
import PropTypes from "prop-types";
import { Accordion, Card, Button, ListGroup } from "react-bootstrap";
import NavbarLink from "../NavbarLink";
const Amenities = ({ amenities_add }) => {
    return (
        <Card id="amenities-toggle-list">
            <Card.Header>
                <Accordion.Toggle
                    as={Button}
                    variant="light"
                    eventKey="amenities-toggle-list"
                >
                    <span className="text-dark">
                        <i className="fa fa-swimming-pool" /> Amenities
                    </span>
                </Accordion.Toggle>
            </Card.Header>

            <Accordion.Collapse eventKey="amenities-toggle-list">
                <Card.Body className="p-0">
                    <ListGroup>
                        <ListGroup.Item>
                            <NavbarLink
                                to="/app/amenities"
                                className="dropdown-item"
                                label={`View Amenities`}
                            />
                        </ListGroup.Item>

                        {amenities_add && (
                            <ListGroup.Item>
                                <a
                                    href="/app/amenities/add"
                                    className="dropdown-item"
                                >
                                    Add Amenity
                                </a>
                            </ListGroup.Item>
                        )}
                    </ListGroup>
                </Card.Body>
            </Accordion.Collapse>
        </Card>
    );
};

Amenities.propTypes = { amenities_add: PropTypes.bool };

export default Amenities;